import moment from "moment";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { db } from "../components/Firebase";

const CricketGears = () => {
  const [cricketGears, setCricketGears] = useState([]);
  const [value, setValue] = useState("");
  const Sorted = () => {
    return cricketGears.sort((a, b) =>
      moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
    );
  };
  let navigate = useNavigate();
  useEffect(() => {
    getAllNotes();
  }, [value]);
  const getAllNotes = async () => {
    db.collectionGroup("cricketGears")
      .where("type", "==", value)
      // .orderBy("createdAt")
      .get()
      .then((docs) => {
        //console.log("dd", docs);
        let newNotes = [];
        docs.forEach((doc) => {
          //console.log(doc);
          newNotes.push({ ...doc.data(), id: doc.id });
        });
        //console.log(newNotes);
        setCricketGears([...newNotes]);
      })
      .catch((e) => {
        // //console.log("error");
        // //console.log(e);
      });
  };
  return (
<div class="container-fluid">
  <div class="container">
    <div class="row" style={{ textAlign: "center" }}>
      <div class="col-md-12">
        <h1>Cricket Gears</h1>
        <div class="btn-group">
                  <a class="btn btn-primary" onClick={() => { setValue("shoes"); }} >Shoes</a>
                  <a class="btn btn-primary" onClick={() => { setValue("bat"); }} >Bat</a>
                  <a class="btn btn-primary" onClick={() => { setValue("gloves"); }} >Gloves</a>
                  <a class="btn btn-primary" onClick={() => { setValue("helmet"); }} >Helmet</a>
              </div>
      </div>
    </div>
    <div class="row" style={{ marginTop: "40px" }}>
      <div class="col-md-6" style={{height: "400px", overflowY: 'scroll'}}>
        <h4>{value} Data</h4>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
          {Sorted().map((i) => {
                    return (
            <tr>
              <td onClick={() => {navigate("cricketGearsList", { state: { item: i } }); }} >{i.name}</td>
              <td>{i.createdAt}</td>
            </tr>
            );
                  })}
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <Outlet />
      </div>
    </div>
  </div>
</div> 
  );
};

export default CricketGears;
